import { render, staticRenderFns } from "./FileListConfig.vue?vue&type=template&id=367ad070&scoped=true"
import script from "./FileListConfig.vue?vue&type=script&lang=js"
export * from "./FileListConfig.vue?vue&type=script&lang=js"
import style0 from "./FileListConfig.vue?vue&type=style&index=0&id=367ad070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ad070",
  null
  
)

export default component.exports